export enum ToastMessageCategoryEnum {
    Info = "info",
    Warning = "warning",
    Error = "error",
    Success = "success"
}

export enum ToastMessageAnimationEnum {
    Initial = "initial",
    Appear = "appear",
    Idle = "idle",
    Disappear = "disappear"
}
